import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';

/**
 * Component(s)
 */
import { VSpecDetail } from './v-spec-detail';
import { AppMenuComponentModule } from '../../../shared/components/app-menu/app-menu.module';
import { VehicleDetailHeaderComponentModule } from '../../../shared/components/vehicle-detail-header/vehicle-detail-header.component.module';
import { InViewportModule } from 'ng-in-viewport';
import { OmnitureTags } from 'src/app/shared/omnitureTags';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FlexLayoutModule,
    AppMenuComponentModule,
   VehicleDetailHeaderComponentModule,
    InViewportModule
  ],
  declarations: [
    VSpecDetail
  ],
  exports: [
   VSpecDetail
  ],providers: [ VSpecDetail,OmnitureTags,CurrencyPipe]
})

export class VSpecDetailModule {
}
